<mat-radio-group
  [ngClass]="{ 'column-radio': isColumn }"
  [formControl]="control"
>
  <mat-radio-button
    *ngFor="let c of options"
    [value]="c"
    [disabled]="isReadOnly || (filtering ? !(condition >= c.id) : false)"
    class="paragraph-medium-regular"
    >{{ c.value }}</mat-radio-button
  >
</mat-radio-group>
